import { useQuery } from 'src/modules/apollo';
import { useAppConfig } from 'src/modules/appConfig';
import { GetReferenceChecksDocument } from 'src/types/graphql';

export const useReferenceChecks = () => {
  const { language, locale } = useAppConfig();
  const languageLocale = `${language}-${locale}`;

  const { data, loading, error } = useQuery(GetReferenceChecksDocument, {
    variables: {
      locale: languageLocale,
    },
  });
  const referenceChecks = data?.viewer?.referenceChecks;
  const addReferenceButtonEnabled = false; // Hardcoded to false. This value will be removed and default to true post References wave 2 release.

  return {
    referenceChecks,
    loading,
    addReferenceButtonEnabled,
    error,
  };
};
